import { useState, useEffect } from 'react'
import firebaseApp from './firebase/app'
import { getAuth } from 'firebase/auth'
import { useAuthState } from 'react-firebase-hooks/auth'

const auth = getAuth(firebaseApp)

// #229 decision 11: a permission change reaches the user "on the next load".
//
// Firebase refreshes an ID token on its own roughly every hour, so without this
// an admin who grants a permission and tells the employer to reload watched
// nothing happen for up to an hour. Forcing ONE refresh per page load makes the
// reload the answer it is assumed to be — and once per load, not once per
// mount, because `useUser` is called from many components and a forced refresh
// is a network round trip each time.
let forcedRefreshThisLoad = false

export default function useUser() {
  const [user, loading] = useAuthState(auth)
  const [customClaims, setCustomClaims] = useState(undefined) // undefined = loading, null = no claims
  const [claimsLoading, setClaimsLoading] = useState(true)

  useEffect(() => {
    if (user) {
      setClaimsLoading(true)
      // Get the ID token result which includes custom claims
      const force = !forcedRefreshThisLoad
      forcedRefreshThisLoad = true
      user.getIdTokenResult(force)
        .then(idTokenResult => {
          setCustomClaims(idTokenResult.claims)
          setClaimsLoading(false)
        })
        .catch(error => {
          console.error('Error getting ID token result:', error)
          setCustomClaims(null)
          setClaimsLoading(false)
        })
    } else {
      setCustomClaims(undefined)
      setClaimsLoading(false)
    }
  }, [user])

  // Return user object with customClaims attached
  if (loading || !user) {
    return null
  }

  return {
    ...user,
    customClaims,
    claimsLoading
  }
}
